import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const commonModules = getModules(require.context('./modules', false, /.*\.js$/))
const studentModules = getModules(require.context('./modules/student', false, /.*\.js$/), 'student')
const gradebookModules = getModules(require.context('./modules/gradebook', false, /.*\.js$/), 'gradebook')

let modules = {...commonModules, ...studentModules, ...gradebookModules, };

export default new Vuex.Store({
    modules
})

function getModules(requireContext, prefix = null) {
    return requireContext.keys()
        .map(file =>
            [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)]
        )
        .reduce((modules, [name, module]) => {
            if (module.namespaced === undefined) {
                module.namespaced = true
            }

            return {...modules, [prefix ? prefix + '/' + name : name]: module}
        }, {})
}